import React, { useRef, useEffect } from 'react';

/**
 * AhaBaseEventListener provides a helpful wrapper for listening to events on web components emitted from `aha-base`.
 * Because of how DOM event listeners are registered in React, since since our `aha-base` does not have a React build
 * target, it is currently not possible to listen for events on web components.
 *
 * Usage:
 *
 *   <AhaBaseEventListener
 *     Component="aha-menu"
 *     eventListeners={{
 *       cancel: event => console.log('menu canceled'),
 *       openChanged: event => console.log('openChanged'),
 *     }}
 *   >
 *     <h1>My menu</h1>
 *   </AhaBaseEventListener>
 */
const AhaBaseEventListener = ({ Component, eventListeners, ...props }) => {
  const ref = useRef(null);

  useEffect(() => {
    const { current } = ref;
    if (current) {
      Object.keys(eventListeners).forEach(key =>
        current.addEventListener(key, eventListeners[key], false)
      );
    }

    return () => {
      if (current) {
        Object.keys(eventListeners).forEach(key =>
          current.removeEventListener(key, eventListeners[key], false)
        );
      }
    };
  }, [eventListeners]);

  return <Component ref={ref} {...props} />;
};

export default AhaBaseEventListener;
